/**
 * Take and UUID and return it converted to an integer
 * @param {String} uuid - The UUID to convert
 * @returns - The UUID integer representation
 */
export const generateNumericHash = uuid => {
    const hash = uuid.split('').reduce((acc, char) => {
        const charCode = char.charCodeAt(0)
        acc = ((acc << 5) - acc) + charCode
        return acc & acc
    }, 0)
    
    return Math.abs(hash)
}